import { spawn } from 'redux-saga/effects';
import { watchStatistics } from './statistics';

export function* statisticsSaga() {
  yield spawn(watchStatistics);
}
